export const is18YearsOldDateValue = (): Date => {
  const is18YearsOld = new Date();
  is18YearsOld.setFullYear(new Date().getFullYear() - 18);
  return is18YearsOld;
};
